var map = {
	"./logo_cn_en.svg": 589,
	"./logo_cn_fr.svg": 590,
	"./logo_cn_invert_en.svg": 123,
	"./logo_cn_invert_fr.svg": 124,
	"./logo_cn_invert_nl.svg": 125,
	"./logo_cn_nl.svg": 591
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 588;